import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { useVisitors, formatIt } from "../../lib/visitors";
import { useLang } from "../../lib/i18n";

export const VisitorPopup = () => {
  const data = useVisitors();
  const { tr } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (data && data.total) {
      setOpen(true);
      const t = setTimeout(() => setOpen(false), 8000);
      return () => clearTimeout(t);
    }
  }, [data]);

  return (
    <AnimatePresence>
      {open && data?.total && (
        <motion.div
          data-testid="visitor-popup"
          initial={{ opacity: 0, y: -30, x: "-50%" }}
          animate={{ opacity: 1, y: 0, x: "-50%" }}
          exit={{ opacity: 0, y: -30, x: "-50%" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed top-24 left-1/2 z-[70] w-[90%] max-w-md"
        >
          <div className="relative flex items-center gap-4 bg-[#0e0e0e]/95 backdrop-blur-xl border border-gold/40 px-5 py-4 shadow-2xl shadow-black/60">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold">
              <Sparkles size={20} />
            </span>
            <div className="pr-6">
              <p className="font-sans-ui text-[10px] uppercase tracking-[0.28em] text-gold">
                {tr("Benvenuto in Atelier Divine", "Welcome to Atelier Divine")}
              </p>
              <p className="mt-1 font-serif-display text-lg text-white leading-tight">
                {tr("Sei il visitatore n°", "You are visitor no.")}{" "}
                <span className="text-gold">{formatIt(data.total)}</span>
              </p>
            </div>
            <button
              data-testid="visitor-popup-close"
              onClick={() => setOpen(false)}
              aria-label={tr("Chiudi", "Close")}
              className="absolute top-3 right-3 text-white/50 hover:text-gold transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
